import * as React from 'react'
import * as MediaStore from '../store/Media'
import { useDispatch, useSelector } from 'react-redux'
import MediaEditPopup from './MediaEditPopup'
import { Photo } from '../models/Photo'
import { ApplicationState } from '../store'
import { Tooltip } from '../Tooltip'
import { PhotosFilter } from '../services/PhotosService'

interface Props {
    photo: Photo
    type?: MediaDisplayType
    isSelected?: boolean
    hideEdit?: boolean
    onDelete?: (photo: Photo) => void
    onSelect?: (photo: Photo) => void
}
type MediaDisplayType = 'Select' | 'Hero'

const TypeConstants = {
    Hero: {
        Selected: 'Main photo',
        Select: 'Set as main photo',
    },
    Select: {
        Selected: 'Selected',
        Select: 'Select photo',
    },
}
export const MediaDisplay = (props: Props) => {
    const dispatch = useDispatch()
    const Localization = useSelector((state: ApplicationState) => state.localization.locale)

    const p = props.photo
    const onEdit = () => {
        dispatch(MediaStore.actionCreators.edit(p))
    }
    const onDelete = () => {
        if (props.onDelete) {
            props.onDelete(props.photo)
        } else {
            dispatch(MediaStore.actionCreators.delete(p, new PhotosFilter()))
        }
    }
    const onHeroImageChanged = () => {
        if (props.onSelect) props.onSelect(p)
    }
    const str = TypeConstants[props.type || 'Select']
    const renderStats = (photo: Photo) => {
        return <div className="photo-usage-stats">
            {photo.usedInTours?.length > 0
                ? <Tooltip style={{ width: 200 }} richText={<>{p.usedInTours.map(u => <p key={u.id}>{u.name}</p>)}</>}><span>{p.usedInTours.length} tours</span></Tooltip>
                : undefined
            }
            {photo.usedInCountries?.length > 0
                ? <Tooltip style={{ width: 200 }} richText={<>{p.usedInCountries.map(u => <p key={u.id}>{u.name}</p>)}</>}><span>{p.usedInCountries.length} countries</span></Tooltip>
                : undefined
            }
            {photo.usedInWidgets?.length > 0
                ? <Tooltip style={{ width: 200 }} richText={<>{p.usedInWidgets.map(u => <p key={u.id}>{u.name}</p>)}</>}><span>{p.usedInWidgets.length} widgets</span></Tooltip>
                : undefined
            }
        </div>
    }
    return (
        <li key={p.id} className="uploaded-item">
            <MediaEditPopup photo={p} />
            <img src={p.urlSmall} alt={p.title} />
            <div className="uploaded-item-tools">
                {p.hasUsageStats ? renderStats(p) : undefined}
                {props.onSelect && (
                    <Tooltip
                        style={props.isSelected ? undefined : { width: 140 }}
                        text={
                            props.isSelected ? Localization.getString(str.Selected) : Localization.getString(str.Select)
                        }
                    >
                        <a
                            onClick={onHeroImageChanged}
                            className={`uploaded-item-tools--main${props.isSelected ? ' is-active' : ''}`}
                        ></a>
                    </Tooltip>
                )}
                {!props.hideEdit && (
                    <Tooltip text={Localization.getString('Edit')}>
                        <a onClick={onEdit} className="uploaded-item-tools--edit"></a>
                    </Tooltip>
                )}
                <Tooltip text={Localization.getString('Delete')}>
                    <a onClick={onDelete} className="uploaded-item-tools--remove"></a>
                </Tooltip>
            </div>
            {(p.title || p.description) && <Tooltip style={{ width: 200 }} richText={<>
                <strong><p>{p.title}</p></strong>
                <p>{p.description}</p>
            </>}>
                <i className='fa fa-info-circle media-display-info' />
            </Tooltip>}
        </li>
    )
}
